<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl" style="position: relative !important;">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div class="text-container">
        <div class="title-area">
          <div class="d-flex">
            <h1 class="page-title h2">
              <span
                id="set-information"
                class=""
              >{{ screentexts[7]?screentexts[7].element_text:'' }}
                <!-- <PopupBubble
                  v-if="screentexts[7] && screentexts[7].element_bubbletext != '' && screentexts[7].element_bubbletext !== null"
                  element_id="set-information"
                  :screen_id="screen_id"
                  screenelement_id="7"
                  :bubbletext="screentexts[7]?screentexts[7].element_bubbletext:''"
                /> -->
              </span>
            </h1>

          </div>
        </div>
        <p>{{ screentexts[8]?screentexts[8].element_text:'Before setting up your survey, tell us about the Group!' }}</p>
        <b-form-group class="pl-0 ml-0">
          <template slot="label">
            {{ screentexts[9]?screentexts[9].element_text:'Give your group a name' }}
          </template>
          <b-form-input
            :class="`${anon ? 'g-anon' : '' }`"
            v-model="group.group_name"
            placeholder="Group name"
          />
        </b-form-group>
        <b-form-group class="pl-0 ml-0">
          <template slot="label">
            {{ screentexts[10]?screentexts[10].element_text:'Save to folder' }}
          </template>
          <template slot="description">
            {{ screentexts[10]?screentexts[10].element_bubbletext:'Do you want to put your group in a folder? Tell us where!' }}
          </template>
          <b-form-select
            v-model="group.group_folder_id"
            :options="folder_options"
          />
        </b-form-group>
        <b-form-group class="pl-0 ml-0">
          <template slot="label">
            {{ screentexts[11]?screentexts[11].element_text:'Group language' }}
          </template>
          <template slot="description">
            {{ screentexts[11]?screentexts[11].element_bubbletext:'Which language would you like to use for this group? You can cange this later.' }}
          </template>
          <b-form-select
            v-model="group.group_language_id"
            :options="language_options"
          />
        </b-form-group>
        <b-form-group class="pl-0 ml-0">
          <template slot="label">
            {{ screentexts[12]?screentexts[12].element_text:'Norm values' }}
          </template>
          <template slot="description">
            {{ screentexts[12]?screentexts[12].element_bubbletext:'Which set of norm values do you want to use for this group? You can cange this later.' }}
          </template>
          <b-form-select
            v-model="group.group_normvalues_id"
            :options="norm_values_options"
          />
        </b-form-group>
        <!-- b-form-group class="col-12 col-md-8 pl-0 ml-0">
          <template slot="label">
            {{ screentexts[13]?screentexts[13].element_text:'Select email reply address' }}
          </template>
          <template slot="description">
            {{ screentexts[13]?screentexts[13].element_bubbletext:'If you want replies to the e-mails for this group to be sent from another e-mail address, enter it here. Mails are always sent from gdq@gdq.se.' }}
          </template>
          <b-form-input
            v-model="group.group_reply_to"
            placeholder="Select email reply address"
          />
        </b-form-group -->
        <b-row>
      &nbsp;
        </b-row>
        <div class="d-flex justify-content-between w-100 mb-5">
          <div class="">
            <b-link
              to="/create"
              class="float-left"
            >
              <b-button variant="secondary">
                &lt;<span class="d-none d-sm-inline"> Back</span>
              </b-button>
            </b-link>
          </div>
            <b-link
              v-if="group.group_name != '' && group.group_language_id != 0 && group.group_normvalues_id != 0"
              to="/create/group/members"
              class="float-right"
            >
              <b-button variant="primary">
                <span class="d-none d-sm-inline">Next </span>&gt;
              </b-button>
            </b-link>
            <b-button
              v-if="group.group_name == '' || group.group_language_id == 0 || group.group_normvalues_id == 0"
              disabled
              variant="primary"
              class="disabled float-right"
            >
              <span class="d-none d-sm-inline">Next </span>&gt;
            </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import PopupBubble from './PopupBubble.vue'

export default {
  name: 'CreateGroup',
  components: {
    Navbar,
    Breadcrumb
    // PopupBubble
  },
  data () {
    return {
      screen_id: 3,
      screentexts: [],
      group: {
        user_id: this.$store.state.user_id,
        id: this.$store.state.currentgroup.id,
        group_folder_id: this.$store.state.currentgroup.group_folder_id,
        group_name: this.$store.state.currentgroup.group_name,
        group_language_id: this.$store.state.currentgroup.group_language_id,
        group_normvalues_id: this.$store.state.currentgroup.group_normvalues_id
        // group_reply_to: (this.$store.state.currentgroup.group_reply_to != '') ? this.$store.state.currentgroup.group_reply_to : this.$store.state.user.email
      }
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    folder_options: {
      get () {
        var items = this.$store.state.folders
        var options = []
        options.push({ value: 0, text: 'No folder' })
        for (var i = 0; i < items.length; i++) {
          var option = {
            value: items[i].id,
            text: items[i].folder_name
          }
          options.push(option)
        }
        return options
      },
      set () {
        return true
      }
    },
    language_options: {
      get () {
        var items = this.$store.state.languages
        var options = []
        options.push({ value: 0, text: 'Please select a language' })
        for (var i = 0; i < items.length; i++) {
          var option = {
            value: items[i].id,
            text: items[i].language_name
          }
          options.push(option)
        }
        return options
      },
      set () {
        return true
      }
    },
    norm_values_options: {
      get () {
        var items = this.$store.state.normvalues_countries
        var options = []
        options.push({ value: 0, text: 'Please select norm values' })
        for (var i = 0; i < items.length; i++) {
          var option = {
            value: items[i].country_id,
            text: items[i].country_name
          }
          options.push(option)
        }
        return options
      },
      set () {
        return true
      }
    }
  },
  created () {
    this.folders_get()
    this.screentexts_get()
    this.languages_get()
    this.normvalues_countries_get()
  },
  async beforeRouteLeave (to, from, next) {
    // We are going forward - save
    if (to.name == 'creategroupmembers') {
      if (this.$store.state.currentgroup.id == 0) {
        await this.group_create()
      } else {
        await this.group_save()
      }
    }
    next()
  },
  methods: {
    folders_get: function () {
      this.$store.dispatch('folders_fetch')
    },
    languages_get: function () {
      this.$store.dispatch('languages_fetch')
    },
    normvalues_countries_get: function () {
      this.$store.dispatch('normvalues_countries_fetch')
    },
    group_create: async function () {
      await this.$store.dispatch('group_create', {
        'group': this.group
      })
    },
    asyncgroup_save: async function () {
      await this.$store.dispatch('group_save', {
        'group': this.group
      })
    },
    screentexts_get: function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    }
  }
}
</script>
<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
